export default "__VITE_ASSET__gLEgc9QS__"